"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.remitaTransactionStatus = exports.remitaValidation = exports.remitaRequest = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const network_1 = __importStar(require("../../utils/network"));
exports.remitaRequest = (0, toolkit_1.createAsyncThunk)('profile/remita/request', async (payload, { getState, rejectWithValue }) => {
    const { auth } = getState();
    return (0, network_1.default)(`${network_1.BASE_URL}/app/api/v2/remita/request-authorization/${payload.loan_application_id}/`, { clientBody: payload, method: 'POST', token: auth.token }, { rejectWithValue });
});
exports.remitaValidation = (0, toolkit_1.createAsyncThunk)('profile/remita/validation', async (payload, { getState, rejectWithValue }) => {
    const { auth } = getState();
    return (0, network_1.default)(`${network_1.BASE_URL}/app/api/v2/remita/validate-authorization/${payload.loan_application_id}/`, { clientBody: payload, method: 'POST', token: auth.token }, { rejectWithValue });
});
exports.remitaTransactionStatus = (0, toolkit_1.createAsyncThunk)('profile/remita/transaction-status', async (payload, { getState, rejectWithValue }) => {
    const { auth } = getState();
    return (0, network_1.default)(`${network_1.BASE_URL}/app/api/v2/remita/status/${payload.loan_application_id}/`, { clientBody: {}, method: 'GET', token: auth.token }, { rejectWithValue });
});
